import { render, staticRenderFns } from "./element-dialog.vue?vue&type=template&id=86e37044&scoped=true&"
import script from "./element-dialog.vue?vue&type=script&lang=js&"
export * from "./element-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e37044",
  null
  
)

export default component.exports